export default "__VITE_ASSET__DryxN46q__"